export default {
  errorMessage: 'Please resolve all issues and try again',
  accessToDownPayment: {
    values: {
      s: {
        score: 0,
        copy:
          'While there are an increasing number of zero down payment programs, you will also face closing costs and many other one-time expenses as a homeowner. Insufficient savings may not prevent you from buying a home but it is a strong indication that you may not be prepared for the ongoing financial requirements of homeownership.',
        consideration:
          "If you want to be able to buy a home in the future, we suggest that you start an aggressive savings plan. If you have plan and stick to it, you'll be surprised at how quickly your saving can add up!"
      }
    },
    trackingName: 'which best describes your access to a down payment'
  },
  downPayment: {
    default: '',
    min: 0,
    max: 100
  },
  creditHistory: {
    trackingName: 'which of the following best describes your credit history'
  },
  lengthOfStay: {
    values: {
      s: {
        score: 0,
        copy:
          'In general, the longer you plan to stay in your new home, the more it makes sense to buy.  You said you plan to stay less than a year; so this points strongly in favor of renting.'
      },
      m: {
        score: 3,
        copy: {
          buy:
            'In general, the longer you plan to stay in your new home, the more it makes sense to buy.  You said you plan to stay at least a year, but probably not more than five years.  This points somewhat in favor of buying.',
          rent:
            'In general, the longer you plan to stay in your new home, the more it makes sense to buy.  You said you plan to stay a relatively short time 1-5 years; so, your length-of-stay is not a strong reason to buy.'
        }
      },
      l: {
        score: 5,
        copy:
          "In general, the longer you plan to stay in your new home, the more it makes sense to buy.  You said you're pretty sure you'll stay in your new home more than five years, so this points strongly in favor of buying."
      }
    },
    weight: 5
  },
  location: {
    values: {
      s: {
        score: 2,
        copy:
          "If property values are rising in the location of your new home, it generally makes more sense to buy.  Since you indicated that property values don't seem to be changing much in the location of your new home, this points strongly in favor of renting."
      },
      m: {
        score: 3,
        copy: {
          buy:
            'If property values are rising in the location of your new home, it generally makes more sense to buy.  Since you indicated that property values are rising, this points in favor of buying.',
          rent:
            'If property values are rising in the location of your new home, it generally makes more sense to buy.  You indicated that values are rising at an ordinary rate; but in light of all the factors, it seems like renting is better for you overall.  (Note: If you had indicated that home prices are rising at an exceptional rate, then this may have tippd the balance in favor of buying.)'
        }
      },
      l: {
        score: 5,
        copy:
          'If property values are rising in the location of your new home, it generally makes more sense to buy.  Since you indicated that property values are rising significantly, this points strongly in favor of buying.'
      }
    },
    weight: 5
  },
  tax: {
    values: {
      s: {
        score: 4,
        copy:
          'You can deduct the interest you pay on your mortgage from your taxable income.  In the early years of a mortgage, mortgage interest payments are large, so this tax deduction can save you a lot of money in taxes.  You indicated that you may benefit from this tax deduction, so this points in favor of buying.'
      },
      m: {
        score: 1,
        copy:
          'You can deduct the interest you pay on your mortgage from your taxable income.  In the early years of a mortgage, interest payments are large, so this tax deduction can save you a lot of money in taxes. However, you indicated that this deduction may not help you, so this points in favor of renting.'
      }
    },
    weight: 3
  },
  budget: {
    values: {
      s: {
        score: 2,
        copy:
          'Generally speaking, owning a home imposes larger monthly costs than renting because you need to pay the costs of maintenance, improvements, and property taxes, as well as your mortgage. Since you indicated that your budget is tight after you pay your current bills, this points in favor of renting.'
      },
      m: {
        score: 3,
        copy:
          'Generally speaking, owning a home imposes larger monthly costs than renting because you need to pay the costs of maintenance, improvements and probperty taxes, as well as your mortgage.  Since you indicate that you have some flexibility in your monthly budget, this points in favor of buying.'
      },
      l: {
        score: 4,
        copy:
          'Generally speaking, owning a home imposes larger monthly costs than renting because you need to pay the costs of maintenance, improvements and probperty taxes, as well as your mortgage.  Since you indicate that you have some flexibility in your monthly budget, this points in favor of buying.'
      }
    },
    weight: 1
  },
  maintenance: {
    values: {
      s: {
        score: 5,
        copy:
          'Owning a home requires a lot more effort on maintenance than renting does. You indicated that you are willing to put in the extra effort required to maintain a home that you own, so this points in favor of your buying.'
      },
      m: {
        score: -5,
        copy:
          "Owning a home requires a lot more effort on maintenance than renting does.  You indicated that you'd prefer to let someone else worry about maintaining your home, so this points strongly in favor of renting."
      }
    },
    weight: 1
  },
  lifestyle: {
    values: {
      s: {
        score: 4,
        copy:
          'Owning a home will require that you make a commitment to staying in one place for a while.  You indicated that you are willing to "settle down" in one place for a while, so this points in favor of your buying.'
      },
      m: {
        score: -5,
        copy:
          'Owning home will require that you make a committment to staying in one place for a while.  You indicated that you really want to have the freedom to "pick up and go," so this points strongly in favor of renting.'
      }
    },
    weight: 1
  },
  recommendation: {
    noDownPayment:
      "Based on your answers, Because you don't have any savings or access to a lump sum, you should reconsider your plan to purchase a home at this time. The factors we considered in formulating this recommendation are explained below:",
    buy: 'We think that buying is a good choice for you.',
    rent: 'We think that renting is a good choice for you.',
    either:
      'Both buying and renting can have advantages for you.  However we think that renting is probably the right choice for you.'
  },
  affordability: {
    buy:
      'Over the medium and long term, there are usually significant financial benefits to owning your home, rather then renting it.  However, as a homeowner, you will have a steady stream of fairly significant financial obligations that most renters do not have. So, if you are currently strapped for cash each month, then this would not be a good time for you to buy, even if some lenders are willing to give you a mortgage.  However, in your case, it appears that you are not strapped for cash each month.  So, this points in favor of buying.',
    rent:
      'Over the medium and long term, there are usually significant financial benefits to owning your home, rather then renting it.  However, as a homeowner, you will have a steady stream of fairly significant financial obligations that most renters do not have. So, if you are currently strapped for cash each month, then this would not be a good time for you to buy, even if some lenders are willing to give you a mortgage.  In your case, it appears that you are strapped for cash each month.  So, this points in favor of renting.'
  }
}
